<script setup>
import Text from "@/v2/primitives/Text/Text.vue";
import { computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  sponsorMedia: {
    type: Array,
    default: () => [],
  },
});
const sponsorBarWidth = computed(() => `${20 * props.sponsorMedia.length}%`);
</script>

<template>
  <div class="sponsor-bar-subtle" data-cmsid="sponsor-bar">
    <div class="sponsor-bar-subtle__container">
      <div v-if="label" class="sponsor-bar-subtle__container__label">
        <Text variant="body-small">
          {{ label }}
        </Text>
      </div>

      <div class="sponsor-bar-subtle__container__slot">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.sponsor-bar-subtle {
  width: v-bind(sponsorBarWidth);
  max-width: 70%;
  height: 100%;
  margin: 0 auto;
  user-select: none;

  &__container {
    &__label {
      background: var(--sponsor-bar-surface);
      padding: var(--spacing-xs) var(--spacing-sm);
      width: fit-content;
      border-radius: var(--border-radius-small);
      color: var(--sponsor-bar-label);
      margin: 0 auto;
      z-index: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      .text {
        margin-bottom: calc(var(--spacing-md) * -1);
      }
    }

    &__slot {
      display: flex;
      padding: var(--spacing-sm) var(--spacing-lg);
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      background-color: var(--sponsor-bar-surface);
      border-radius: var(--border-radius-extra-large);
      height: var(--units-17);
    }
  }
}
</style>
